export default __webpack_public_path__ + "static/media/Nunito-Regular.e4eb7682.ttf";